module.exports = __webpack_public_path__ + "assets/img/LTC023.e7e0f5f6.png";